define(['jquery', 'availabilityForm'], function($, availabilityForm) {
    var self = this;
    var $container = $('[data-role="basket-container"]');
    var onSuccess, onFailure;
    var makeRequest = function(method, params) {
        var AJAX_URL = '/wp-admin/admin-ajax.php';
        var request = Object.assign({ action: 'basket', 'method': method }, params);

        $('.loader').removeClass('hidden');

        $.post(AJAX_URL, request)
            .done(function(response) {
                render(response);
                $('html,body').scrollTop(0);
            })
            .fail(function() {
                console.log('Basket Error');
                console.log('Request', request);

                if ($.isFunction(onFailure)) {
                    onFailure();
                }
                $('.loader').addClass('hidden');
            });
    };

    var render = function(html) {
        $container.html(html);
        bindButtons();

        if ($.isFunction(onSuccess)) {
            onSuccess();
        } else {
            $('.loader').addClass('hidden');
        }
    };

    var get = function() {
        makeRequest('get');
    };

    var add = function(item) {
        makeRequest('add', item);
    };

    var remove = function(id) {
        makeRequest('remove', { id: id });
    };

    var hasItems = function() {
        return $('[data-bind="basket"].active', $container).length;
    };

    var bindButtons = function() {
        $('[data-bind="basket"].active', $container).click(function() {
            var $contents = $(this).parent().find('.basket-contents');

            if ($contents.hasClass('open')) {
                $contents.removeClass('open');
            } else {
                $contents.addClass('open');
            }
        });

        $('[data-bind="remove-item"]', $container).click(function() {
            var id = $(this).data('value');

            remove(id);
        });

        $('button.add-another-room').on('click', function(e) {
            var $contents = $(this).parent().parent().find('.basket-contents', $container);

            if ($contents.hasClass('open')) {
                $contents.removeClass('open');
            } else {
                $contents.addClass('open');
            }
        });
    };

    return {
        get: function() {
            get();
        },
        add: function(item) {
            add(item);
        },
        remove: function(item) {
            remove(item);
        },
        setOnSuccess: function(cb) {
            onSuccess = cb;
        },
        setOnFailure: function(cb) {
            onFailure = cb;
        },
        hasItems: function() {
            return hasItems();
        }
    };
});